import { useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, House, Sparkles, UserRound } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useHaptic } from '@/app/hooks/useHaptic';

export type TabId = 'home' | 'course' | 'ai' | 'profile';

const tabs: { id: TabId; label: string; route: string; icon: typeof House }[] = [
  { id: 'home', label: 'Главная', route: '/home', icon: House },
  { id: 'course', label: 'Обучение', route: '/course', icon: BookOpen },
  { id: 'ai', label: 'ИИ', route: '/assistant', icon: Sparkles },
  { id: 'profile', label: 'Профиль', route: '/profile', icon: UserRound },
];

/** Нижняя навигация. Активная вкладка определяется экраном, а не маршрутом. */
export function TabBar({ active }: { active: TabId }) {
  const navigate = useNavigate();
  const location = useLocation();
  const haptic = useHaptic();

  return (
    <nav
      aria-label="Основная навигация"
      className="fixed inset-x-0 bottom-0 z-30 mx-auto grid max-w-[520px] grid-cols-4 border-t border-line/70 bg-surface/95 px-1 pt-1.5 backdrop-blur"
      style={{ paddingBottom: 'calc(9px + var(--bd-safe-bottom))' }}
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            aria-current={isActive ? 'page' : undefined}
            onClick={() => {
              haptic.selection();
              if (location.pathname !== tab.route) navigate(tab.route);
            }}
            className={cn(
              'bd-focus flex flex-col items-center gap-1 rounded-lg py-1 text-[9.5px] transition-colors',
              isActive ? 'text-brand' : 'text-muted',
            )}
          >
            <Icon className="h-[19px] w-[19px]" aria-hidden />
            <span>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
